<template>
  <div id="app" ref="appContent">
    <keep-alive  v-if="$route.meta.keepAlive">
      <router-view></router-view>
    </keep-alive>

      <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
 
<script>
import Vue from "vue";
var app = new Vue({
  name: "app",
});

export default app;
</script>

<style scoped>
#app {
  height: 100%;
  width: 100%;
}
.el-pager li.active {
  color: #c01b22 !important;
}
.appImg {
  width: 100%;
  height: 100%;
}
::-webkit-scrollbar {
  width: 8px;
  height: 16px;
  background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}

.el-carousel__indicators--horizontal {
  bottom: 6px !important;
  left: 80% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue